import React from 'react'
import { Typography } from '@mui/material'

export interface SumitErrorMessageProps {
  message?: string
  isError: boolean
}

export const SubmitErrorMessage = ({ isError, message }: SumitErrorMessageProps): React.ReactElement | null => {
  if (!isError) return null

  return (
    <Typography sx={{ mb: 2 }} color="error.main">
      {message ?? 'Произошла непредвиденная ошибка'}
    </Typography>
  )
}
